import { createTheme, globalTheme } from '@cld/component-theme';

const { palette } = globalTheme;
const { brand } = globalTheme.palette;

export const websiteTheme = createTheme({
  headlines: {
    fontFamily: 'sofia-pro',
    xxxxl: {
      fontSize: '64px',
      lineHeight: '64px',
      contrastInvert: {
        color: palette.contrastInvert,
        fontWeight: 'bold',
      },
      bold: {
        color: brand.darkBlue,
        fontWeight: 'bold',
      },
    },
    xxxl: {
      fontSize: '46px',
      lineHeight: 'normal',
      contrastInvert: {
        color: palette.contrastInvert,
        fontWeight: 'bold',
      },
      bold: {
        color: brand.darkBlue,
        fontWeight: 'bold',
      },
    },
    xl: {
      fontSize: '28px',
      lineHeight: 'normal',
      contrastInvert: {
        color: palette.contrastInvert,
        fontWeight: 'bold',
      },
      bold: {
        color: brand.darkBlue,
        fontWeight: 'bold',
      },
    },
    lg: {
      fontSize: '18px',
      lineHeight: '1.5',
      contrastInvert: {
        color: palette.contrastInvert,
        fontWeight: 'normal',
      },
      bold: {
        color: brand.darkBlue,
        fontWeight: 'normal',
      },
    },
    md: {
      fontSize: '16px',
      lineHeight: '1.69',
      contrastInvertBold: {
        color: palette.contrastInvert,
        fontWeight: 'bold',
      },
      bold: {
        color: brand.darkBlue,
        fontWeight: 'bold',
      },
      contrastInvert: {
        color: palette.contrastInvert,
        fontWeight: 'normal',
      },
      regular: {
        color: brand.darkBlue,
        fontWeight: 'normal',
      },
    },
    sm: {
      fontSize: '14px',
      lineHeight: '1.93',
      bold: {
        color: brand.darkBlue,
        fontWeight: 'bold',
      },
      contrastInvert: {
        color: palette.contrastInvert,
        fontWeight: 'normal',
      },
    },
  },
  brandText: {
    fontFamily: 'Inter',
    lg: {
      fontSize: '18px',
      lineHeight: '1.5',
      contrastInvert: {
        color: palette.contrastInvert,
        fontWeight: 'normal',
      },
      bold: {
        color: brand.darkBlue,
        fontWeight: 'normal',
      },
      regular: {
        color: brand.darkBlue,
        fontWeight: 'normal',
      },
    },
    sm: {
      fontSize: '14px',
      lineHeight: '1.93',
      contrastInvert: {
        color: palette.contrastInvert,
        fontWeight: 'normal',
      },
      bold: {
        color: brand.darkBlue,
        fontWeight: 'bold',
      },
      accentCoral: {
        color: brand.accentCoral,
        fontWeight: 'bold',
      },
    },
    xs: {
      fontSize: '12px',
      lineHeight: '2.25',
      contrastInvert: {
        color: palette.contrastInvert,
        fontWeight: 'normal',
      },
      regular: {
        color: brand.darkBlue,
        fontWeight: 'normal',
      },
    },
  },
});
